import { useContext, useState } from "react";
import { AppContext } from "components/App/AppContext";
import { Alert, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icon } from "components/Icon";
import { Button } from "components/Button";
import { AccountForm } from "components/AccountForm";
import { getCustomerNumber } from "components/utils/user";

const GUEST_ALERT_DISMISSED_KEY_PREFIX = "guestAlertDismissed";

export const GuestAlert = () => {
    const dismissedKey = `${GUEST_ALERT_DISMISSED_KEY_PREFIX}:${getCustomerNumber()}`;
    const [showAlert, setShowAlert] = useState(() => localStorage.getItem(dismissedKey) !== "true");
    const [showForm, setShowForm] = useState(false);
    const { settings } = useContext(AppContext);

    const dismissAlert = () => {
        localStorage.setItem(dismissedKey, "true");
        setShowAlert(false);
    };

    return (
        <>
            <Alert show={showAlert} variant="info" className="rounded-0 rounded-md border-0 border-md">
                <Container fluid="xxl" className="px-0 px-md-4 d-flex align-items-center gap-3" style={{ maxWidth: settings.maxWidth }}>
                    <Icon icon={["fal", "id-badge"]} className="fs-6" />
                    <div className="flex-grow-1 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
                        <div className="flex-grow-1 fs-7 d-flex flex-column">
                            <b>You are logged in as a Guest</b>
                            <span>Would you like to create an account? (Not required)</span>
                        </div>
                        <Button variant="primary" onClick={() => setShowForm(true)}>
                            Create Account
                        </Button>
                    </div>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Close</Tooltip>}>
                        <span>
                            <Button variant="link" className="text-secondary-emphasis" aria-label="Close" onClick={dismissAlert}>
                                <Icon icon={["fal", "xmark"]} />
                            </Button>
                        </span>
                    </OverlayTrigger>
                </Container>
            </Alert>
            <AccountForm show={showForm} onClose={() => setShowForm(false)} onCompleted={() => setShowAlert(false)} />
        </>
    );
};
